// extracted by mini-css-extract-plugin
export var quillEditor = "_mx-1";
export var variable = "_mx-0";